import { cn } from "@/lib/utils";
import { useDateFormat } from "@/features/utils/i18n";
import { useEffect, useState } from "react";

export const TimeColumn = ({
  timeSlots,
}: {
  timeSlots: { hour: number; minute: number }[];
}) => {
  const { format } = useDateFormat();
  return (
    <div className="sticky left-0 z-10 bg-background">
      <CurrentTime />

      {timeSlots.map(({ hour, minute }) => {
        if (minute === 0) {
          return (
            <div
              key={`time-${hour}-${minute}`}
              className="relative h-3 border-b border-b-slate-500/5 border-r pr-1 text-right text-xs text-muted-foreground"
            >
              <div className="absolute w-full h-px bg-slate-500/25 -top-px" />
              <span className="text-xs absolute w-max mx-auto px-1 right-0 left-0 -translate-y-1/2 text-right bg-background">
                {/* "p", the locale's own short time: "hh:mm" was a 12-hour
                    clock with no AM/PM, so 13:00 read as 01:00 in the night. */}
                {format(new Date().setHours(hour, minute), "p")}
              </span>
            </div>
          );
        }
        return (
          <div
            key={`time-${hour}-${minute}`}
            className={cn("h-3 border-b border-b-slate-500/5 border-r")}
          />
        );
      })}
    </div>
  );
};

const CurrentTime = () => {
  const { format } = useDateFormat();
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      // Force re-render every minute to update the current time indicator
      setCurrentTime(new Date());
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="absolute left-0 top-0 w-full h-1 pointer-events-none text-pink z-10"
      style={{
        top: `${((currentTime.getHours() * 60 + currentTime.getMinutes()) / (24 * 60)) * 100}%`,
      }}
    >
      <div className="absolute left-0 top-0 w-full h-0 border-t border-pink -translate-y-1/2" />
      <span className="text-xs absolute w-max mx-auto px-1 right-0 left-0 -translate-y-1/2 text-right bg-background">
        {format(currentTime, "p")}
      </span>
    </div>
  );
};
